import type { DeepPartial } from '@luna/utils-ts';

import type { StandingOrders } from './StandingOrders';

export const SK: DeepPartial<StandingOrders> = {
    sweepOrders: {
        enabled: false,
    },
};
